<script setup lang="ts">
import { getCurrentInstance } from 'vue';

import type { Selection } from '@/types/configuration';

import TheList from '@/components/mode-list/TheList.vue';
import { i18n } from '@/shared-instance';
import { useFiltersStore } from '@/stores/useFiltersStore';

const props = defineProps<{ selection?: Selection | string }>();
i18n.install(getCurrentInstance()!.appContext.app);
const filtersStore = useFiltersStore();

const parsedTaxonomies: Selection = typeof props.selection === 'string'
  ? JSON.parse(props.selection)
  : props.selection ?? { taxonomies: [], products: [] };

if (parsedTaxonomies.taxonomies.length) {
  filtersStore.setListSelectionPreset(parsedTaxonomies.taxonomies);
}
</script>

<template>
  <TheList />
</template>
